/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M17.6 7.1c0-3.6-3-6.6-6.6-6.6-2.8 0-5.2 1.8-6.1 4.2C2.4 5.6.6 8 .6 10.9c0 3.6 3 6.6 6.6 6.6 2.8 0 5.2-1.8 6.2-4.3 2.4-.9 4.2-3.3 4.2-6.1zM7.2 16c-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1S10 16 7.2 16zm5.4-8.9c-.4-.6-1-1.2-1.6-1.6h.1c.8 0 1.5.7 1.5 1.5v.1zm1.2 4.3v-.5c0-.7-.1-1.4-.3-2.1.4-.5.6-1.1.6-1.8 0-1.7-1.3-3-3-3-.7 0-1.3.2-1.8.6-.7-.2-1.4-.3-2.1-.3h-.5C7.6 2.9 9.2 2 11 2c2.8 0 5.1 2.3 5.1 5.1 0 1.8-1 3.3-2.3 4.3z" />
      <path d="M7.1 8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.4-3-3-3zm0 4.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconCoins = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconCoins.defaultProps = {
  theme,
};
IconCoins.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconCoins.displayName = 'IconCoins';
export { IconCoins };
